import { PRIVACY_LABEL, PRIVACY_URL, TERMS_LABEL, TERMS_URL } from '../../../config/aiDisclaimer';

export type NavLinksInterface = Record<string, { link: string; label: JSX.Element | string }[]>

export const footerNavLinks = [
  {
    link: TERMS_URL,
    label: TERMS_LABEL,
    target: '_blank',
  },
  {
    link: PRIVACY_URL,
    label: PRIVACY_LABEL,
    target: '_blank',
  },
  // {
  //   link: '#',
  //   label: 'Feedback',
  // },
  // {
  //   link: '#',
  //   label: 'Help Center',
  // },
  // {
  //   link: '#',
  //   label: 'Support',
  // },
]
